<template>
    <validation-observer tag="div" ref="form">
      <validation-provider vid="name" :name="lodash.startCase($t('services.name'))" rules="required" v-slot="{ validated, errors }">
        <b-form-group
            class="row mb-3"
            label-cols-md="2"
            :label="lodash.startCase($t('services.name'))"
            :state="errors[0] ? false : (validated ? true : null)"
            :invalid-feedback="errors[0]"
        >
          <b-form-input
              name="name"
              type="text"
              required
              :state="errors[0] ? false : (validated ? true : null)"
              v-model="model.name"
          ></b-form-input>
        </b-form-group>
      </validation-provider>
      <validation-provider vid="fee" :name="lodash.startCase($t('services.fee'))" rules="required|min_value:0" v-slot="{ validated, errors }">
        <b-form-group
            class="row mb-3"
            label-cols-md="2"
            :label="lodash.startCase($t('services.fee'))+'*'"
            :state="errors[0] ? false : (validated ? true : null)"
            :invalid-feedback="errors[0]"
        >
        <numeral-input
          id="fee"
          name="fee"
          :placeholder="lodash.startCase($t('services.fee'))"
          :state="errors[0] ? false : (validated ? true : null)"
          v-model.number="model.fee"
          format="$ 0,0.[00]"
          lazy-formatter
          @blur="updateLocalStorage"
        />
        </b-form-group>
      </validation-provider>
      <validation-provider vid="top" :name="lodash.upperFirst($t('purchase_orders.top'))" v-slot="{ validated, errors }">
        <b-form-group
            class="row mb-3"
            label-cols-md="2"
            :label="`${lodash.upperFirst($t('purchase_orders.top'))}`"
            :state="errors[0] ? false : (validated ? true : null)"
            :invalid-feedback="errors[0]"
        >
          <b-input-group :append="$t('units.days')">
            <b-form-input
                id="top"
                type="number"
                name="top"
                :placeholder="lodash.upperFirst($t('purchase_orders.top'))"
                style="text-align: right"
                :state="errors[0] ? false : (validated ? true : null)"
                v-model.number="model.duration"
            />
          </b-input-group>
        </b-form-group>
      </validation-provider>
      <validation-provider vid="customer_type" :name="lodash.startCase($t('services.customer_type'))" rules="required" v-slot="{ validated, errors }">
        <b-form-group
            class="row mb-3"
            label-cols-md="2"
            :label="lodash.startCase($t('services.customer_type')) + '*'"
            :state="errors[0] ? false : (validated ? true : null)"
            :invalid-feedback="errors[0]"
        >
          <b-form-checkbox-group
            v-model="model.customer_type"
            :options="options"
            class="mb-3"
            value-field="item"
            text-field="name"
            disabled-field="notEnabled"
            :disabled="model.id"
          ></b-form-checkbox-group>
        </b-form-group>
      </validation-provider>
      <validation-provider v-if="model.id" vid="is_active" :name="lodash.startCase($t('services.is_active'))" rules="required" v-slot="{ validated, errors }">
        <b-form-group
            class="row mb-3"
            label-cols-md="2"
            :label="lodash.startCase($t('services.is_active')) + '*'"
            :state="errors[0] ? false : (validated ? true : null)"
            :invalid-feedback="errors[0]"
        >
          <b-form-checkbox
            switch
            v-model="model.is_active"
            class="mb-3"
            value-field="item"
            text-field="name"
            disabled-field="notEnabled"
          ></b-form-checkbox>
        </b-form-group>
      </validation-provider>
    </validation-observer>
  </template>
  
  <script>
    import FormModel from './model';
  
    export default {
      extends: FormModel,
      mounted() {
        //
      },
      data() {
      return {
          options: [
            { name: 'BRS', item: 'brs' },
            { name: 'LCS', item: 'lcs' },
          ],
          model: {
            ...this.value,
            customer_type: this.value.customer_type ? this.value.customer_type : [],
          }
        }
      }
    }
  </script>
  
  <style lang="scss" scoped>
    ::v-deep{
    .custom-checkbox .custom-control-label::before {
      border-radius: 0.25rem;
    }
  }
  </style>